module.exports = __webpack_public_path__ + "media/sfx_click_5.cda24e90.wav";